import { render, staticRenderFns } from "./appointmentInfo.vue?vue&type=template&id=2651af30&scoped=true"
import script from "./appointmentInfo.vue?vue&type=script&lang=js"
export * from "./appointmentInfo.vue?vue&type=script&lang=js"
import style0 from "./appointmentInfo.vue?vue&type=style&index=0&id=2651af30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651af30",
  null
  
)

export default component.exports